import React from 'react';
import { ScheduleOfEventsModal } from '../../../libs/component-event-modal';
import { useApolloClient } from '@apollo/react-hooks';
import BlankButton from '@xo-union/component-blank-button';

import { useWeddingWebsiteQuery, useEventsQuery } from '../../../generated/graphql';
import { PageItemIcon } from '../PageItemIcon';
import { useEventModalReducer } from '../../WeddingPageCard/useEventModal';
import { onSuccess } from '../../WeddingPageCard/EventList';
import styles from '../pageItemSelector.scss';
import { useFlipper } from '../../../hooks/useFlipper';
import { EventBody } from '../../../libs/gds-api-client';

const EVENT_RR_EXP_CONTROL = 'control';
const EVENT_RR_EXP_VARIANT = 'variant';

const EventGroupItemField = () => {
  const client = useApolloClient();
  const { refetch } = useEventsQuery();
  const { data: weddingData } = useWeddingWebsiteQuery();
  const { open, eventProps, dispatchOpen, dispatchClose } = useEventModalReducer();

  const { variant } = useFlipper(
    process.env.REACT_APP_FLIPPER_EVENT_RAIL_VENUES_LINK_EXP_ID as string,
    EVENT_RR_EXP_CONTROL
  );
  const isExperiment = variant === EVENT_RR_EXP_VARIANT;

  return (
    <>
      <ScheduleOfEventsModal
        open={open}
        weddingId={weddingData?.guestWedding?.id || ''}
        setClose={() => dispatchClose()}
        hasWWS
        onSuccess={e => onSuccess(e, client, refetch)}
        hideDate={weddingData?.weddingWebsite.hideDate}
        onHideDate={() => {}}
        isExperiment={isExperiment}
        {...eventProps}
        event={eventProps.event as EventBody | null}
      />
      <BlankButton
        data-testid="event-page-item"
        className={styles.clickable}
        onClick={() => {
          dispatchOpen({
            type: 'WeddingEvent',
            event: null,
          });
        }}
      >
        <PageItemIcon icon="EventGroupItem" />
      </BlankButton>
    </>
  );
};

export default EventGroupItemField;
